import React, { useMemo } from "react";
import './ChannelsSelector.css';
import { Checkbox } from "@mui/material";
import { IChannel } from "src/app/channel/~store/models/Channel";
import { GetChannelImage } from "src/app/shared/helpers/img-helpers/ImgHelper";

interface IChannelsSelectorProps {
  title: string;
  channels: IChannel[];
  selectedChannelsIds: number[];
  setSelectedChannelsIds: (items: number[]) => void;
}

const ChannelsSelector = (props: IChannelsSelectorProps) => {

  const selectedChannelsIds = useMemo(() => props.selectedChannelsIds ?? [], [props.selectedChannelsIds]);

  const sortedChannels = useMemo(
    () => [...props.channels].sort(_sortChannels), 
    [props.channels, selectedChannelsIds]
  );

  function _sortChannels(first: IChannel, second: IChannel) {
    if (selectedChannelsIds.includes(first.channelId)) {
      return selectedChannelsIds.includes(second.channelId) ? first.name.localeCompare(second.name) : -1;
    }
    else {
      return selectedChannelsIds.includes(second.channelId) ? 1 : first.name.localeCompare(second.name);
    }
  }

  const _onItemClicked = (event: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>, channelId: number) => {
    event.stopPropagation();
    props.setSelectedChannelsIds(selectedChannelsIds.includes(channelId) ? 
      selectedChannelsIds.filter(si => si !== channelId) : 
      [...selectedChannelsIds, channelId])
  }

  return (
      <div className="channels-selector-container">
        <div className="channels-selector__list-container">
          <div className="channels-selector__title">{props.title}</div>
          <div className="channels-selector__items-list">
            {sortedChannels.map((item) => (
              <div key={item.channelId} className="channels-selector__list-item" onClick={(event) => _onItemClicked(event, item.channelId)}>
                <Checkbox color="success"
                  onClick={(event) => _onItemClicked(event, item.channelId)}
                  checked={selectedChannelsIds.includes(item.channelId)}/>
                <img className="channels-selector__list-item-image" src={GetChannelImage(item.type)}/>
                <div className="channels-selector__list-item-name">{item.name}</div>
              </div>))
            }
          </div>

        </div>
      </div>
  )
}

export default ChannelsSelector;
